import AbstractGuestlistDetailsPageController from '../guestlists/abstract-details-controller';

export default class GuestlistRsvpsChangelogPageController extends AbstractGuestlistDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/changelog-controller.js